import { ControlSizesXL, ControlSizesLG, ControlSizesMD, ControlSizesSM } from '../../../helpers/controlSizes/controlSizes/index.js';

const TabsSizesXL = {
    ...ControlSizesXL,
};
const TabsSizesLG = {
    ...ControlSizesLG,
};
const TabsSizesMD = {
    ...ControlSizesMD,
};
const TabsSizesSM = {
    ...ControlSizesSM,
};

export { TabsSizesLG, TabsSizesMD, TabsSizesSM, TabsSizesXL };
